export const STATUS_FLAGS = [
  { key: 'status_own',              label: 'Own',              cssClass: 'status-own' },
  { key: 'status_for_trade',        label: 'For Trade',        cssClass: 'status-for-trade' },
  { key: 'status_want_in_trade',    label: 'Want in Trade',    cssClass: 'status-want-trade' },
  { key: 'status_want_to_buy',      label: 'Want to Buy',      cssClass: 'status-want-buy' },
  { key: 'status_wishlist',         label: 'Wishlist',         cssClass: 'status-wishlist' },
  { key: 'status_pre_ordered',      label: 'Pre-Ordered',      cssClass: 'status-pre-ordered' },
  { key: 'status_previously_owned', label: 'Previously Owned', cssClass: 'status-prev-owned' },
]

export const EMPTY_STATUSES = Object.fromEntries(STATUS_FLAGS.map(s => [s.key, false]))

export const STATUS_LABEL_TO_KEY = Object.fromEntries(STATUS_FLAGS.map(s => [s.label, s.key]))

export function getActiveStatuses(item) {
  return STATUS_FLAGS.filter(s => item[s.key])
}

export function getPrimaryStatusLabel(item) {
  const active = getActiveStatuses(item)
  return active.length > 0 ? active[0].label : ''
}

export function getPrimaryStatusClass(item) {
  const active = getActiveStatuses(item)
  return active.length > 0 ? active[0].cssClass : ''
}
